import React, { useState, useEffect} from 'react';
import Modal from 'react-modal';
import CredentialsModal from '../modals/subscriptionsBell';
import 'resources/css/suscripcionesPortal.css';
import { resourceManager } from 'helpers/resourceManager';

export default function LoadButton(){

    const [modalForm, setModalForm] = useState(null); 
    const [modalIsOpen, setModalIsOpen] = useState(false); 

    useEffect(() => {
        Modal.setAppElement("#subscribeButton");
    });

    const getModalForm = () => {
        setModalForm(<CredentialsModal closeModal={() => setModalIsOpen(false)} />)
        setModalIsOpen(true);
    }

    return (
        <>
            <p>
                <button className="SuscrModal-TopBtn" type="button" id="btnSuscribete" title={resourceManager.getResource('SubscribeBtnTitle')} name="Suscríbete" 
                    onClick={getModalForm}>{resourceManager.getResource('SubscribeTitle')}</button>
            </p>
            <Modal  isOpen={modalIsOpen}>
                {modalForm}
            </Modal>
        </>
    );
}